import { createContext } from 'react';

export interface ToastMethods {
  open: () => void;
  close: () => void;
}

export type ToastRecordInterface = Record<string, ToastMethods>;

export interface ToastContextInterface {
  setToast: (toastName: string, methods: ToastMethods) => null;
  getToast: (toastName: string) => ToastMethods | undefined;
  deleteToast: (toastName: string) => void;
  toasts: Record<string, ToastMethods>;
}

const defaultContext = {
  toasts: {},
  setToast: () => null,
  getToast: () => undefined,
  deleteToast: () => null,
};

export const ToastContext = createContext<ToastContextInterface>(defaultContext);
